import { Button, Drawer, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AddEmployeeDrawer.module.css";
import { API } from "../../../../request/api";
import { Note } from "../../../../helbest";
import { countries } from "../../../../constants/countries-code";

export default function AddEmployeeDrawer({ open, onClose, refetch }) {
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const { t } = useTranslation();
  const isDisable =
    firstName.length === 0 || lastName.length === 0 || phoneNumber.length === 0;

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      setPhoneNumber(inputValue);
    }
  };

  const submitHandler = () => {
    setIsLoading(true);
    API.post
      .createEmployee(firstName, lastName, `+968${phoneNumber}`)
      .then((response) => {
        if (response.success) {
          refetch();
          setFirstName("");
          setLastName("");
          setPhoneNumber("");
          onClose();
          Note.success(t("employees.messages.created"));
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Drawer
      title={t("employees.create.title")}
      placement="bottom"
      onClose={onClose}
      open={open}
      classNames={{
        header: styles.drawerHeader,
        body: styles.drawerBody,
      }}
      style={{
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
      }}
      styles={{
        header: {
          paddingInline: "16px",
          color: "#001860",
        },
        body: {
          padding: "16px",
        },
      }}
      height={390}
      footer={
        <Button
          size="large"
          type="primary"
          style={{
            width: "100%",
          }}
          disabled={isDisable}
          onClick={() => {
            submitHandler();
          }}
          loading={isLoading}
        >
          {t("common.add")}
        </Button>
      }
    >
      <div className={styles.formField}>
        <label>{t("common.first_name")}</label>
        <Input
          variant="outlined"
          size="large"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>
      <div className={styles.formField}>
        <label>{t("common.last_name")}</label>
        <Input
          variant="outlined"
          size="large"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className={styles.formField}>
        <label>{t("login.mobile")}</label>
        <div dir="ltr">
          <Input
            variant="outlined"
            size="large"
            type="tel"
            pattern="[0-9]*"
            inputMode="numeric"
            value={phoneNumber}
            prefix={<span className={styles.phoneNumberPrefix}>+968</span>}
            onChange={handleInputChange}
            maxLength={
              countries.find((country) => country.code === "+968").length
            }
          />
        </div>
      </div>
    </Drawer>
  );
}
